import { BsMetaUtil, getLoopBorrowCapDetails } from "@bridgesplit/abf-react";
import { StatProps, StatRow, StatColumn, Text, TooltipText, Row, MEDIA } from "@bridgesplit/ui";
import { COPY } from "app/constants";
import { formatMultiplier, formatPercent } from "@bridgesplit/utils";
import { useMediaQuery } from "@mui/material";
import { BorrowCapWarning } from "app/components/common";

import { useLoopContext } from "../LoopContext";

export function LoopVaultStats() {
    const { loopExpanded } = useLoopContext();
    const displayAsColumn = useMediaQuery(MEDIA.MD.below);
    const borrowCapWarning = getLoopBorrowCapDetails(loopExpanded);

    const stats: StatProps[] = [
        {
            value: <Text variant="h4">{formatPercent(loopExpanded?.loopVault.maxLeveragedApyPct)}</Text>,
            caption: "Max Net APY"
        },
        {
            value: (
                <BorrowCapWarning variant="h4" borrowCapWarning={borrowCapWarning?.warningMessage}>
                    {BsMetaUtil.formatAmount(
                        loopExpanded?.principalToken,
                        Math.min(
                            loopExpanded?.loopVault?.principalAmountAvailable ?? 0,
                            borrowCapWarning?.remainingGlobalCapacity ?? 0
                        )
                    )}
                </BorrowCapWarning>
            ),
            caption: COPY.AVAILABLE_LIQUIDITY_TERM
        },
        {
            value: (
                <Text variant="h4">
                    {BsMetaUtil.formatAmount(
                        loopExpanded?.collateralToken,
                        loopExpanded?.loopVault.collateralDeposited,
                        {
                            hideSymbol: false
                        }
                    )}
                </Text>
            ),
            caption: (
                <Row spacing={0.5}>
                    <Text variant={displayAsColumn ? "body1" : "body2"} color="caption">
                        {COPY.DEPOSITED_TERM}
                    </Text>
                    <TooltipText
                        helpText={`The total amount of ${BsMetaUtil.getName(
                            loopExpanded?.collateralToken
                        )} used as collateral across ${COPY.LOOP_TERM_PLURAL}`}
                    />
                </Row>
            )
        },
        {
            value: <Text variant="h4">{formatMultiplier(loopExpanded?.loopVault.maxLeverage)}</Text>,
            caption: COPY.MAX_LEVERAGE_TERM
        }
    ];

    if (displayAsColumn) {
        return <StatColumn loading={!loopExpanded} stats={stats} />;
    }

    return <StatRow loading={!loopExpanded} stats={stats} />;
}
